export default {"src":"/_next/static/media/c_Diamond_0.05d24315.svg","height":92,"width":96,"blurWidth":0,"blurHeight":0};